import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const detailRoutes = [
  ['app','/apps/:slug','app-detail'],
  ['website','/websites/:slug','website-detail'],
  ['software','/software/:slug','software-detail'],
  ['product','/products/:slug','product-detail'],
  ['media','/media/:slug','media-detail'],
  ['broadcast','/broadcast/:slug','broadcast-detail'],
  ['research','/research/:slug','research-detail'],
  ['center','/centers/:slug','center-detail'],
  ['children','/children/:slug','children-detail'],
  ['competition','/competitions/:slug','competition-detail'],
  ['exhibition','/exhibitions/:slug','exhibition-detail']
].map(([resourceType,path,name]) => ({
  path,
  name,
  component:() => import('../views/ResourceDetailView.vue'),
  meta:{
    resourceType,
    navSection:'categories',
    ...(!['media','broadcast','competition','exhibition'].includes(resourceType) && { headerTheme:'light' })
  }
}));

const categoryRoutes = [
  {path:'/websites',name:'websites',component:()=>import('../components/category-layouts/WebsitesLayout.vue'),meta:{resourceType:'website',navSection:'categories',headerTheme:'light'}},
  {path:'/programs',name:'programs',component:()=>import('../components/category-layouts/SoftwareLayout.vue'),meta:{resourceType:'software',navSection:'categories',headerTheme:'light'}},
  {path:'/products',name:'products',component:()=>import('../components/category-layouts/ProductsLayout.vue'),meta:{resourceType:'product',navSection:'categories',headerTheme:'light'}},
  {path:'/media',name:'media',component:()=>import('../components/category-layouts/MediaLayout.vue'),meta:{resourceType:'media',navSection:'categories'}},
  {path:'/broadcasts',name:'broadcasts',component:()=>import('../components/category-layouts/BroadcastsLayout.vue'),meta:{resourceType:'broadcast',navSection:'categories'}},
  {path:'/research',name:'research',component:()=>import('../components/category-layouts/ResearchLayout.vue'),meta:{resourceType:'research',navSection:'categories',headerTheme:'light'}},
  {path:'/centers',name:'centers',component:()=>import('../components/category-layouts/CentersLayout.vue'),meta:{resourceType:'center',navSection:'categories',headerTheme:'light'}},
  {path:'/children',name:'children',component:()=>import('../components/category-layouts/ChildrenLayout.vue'),meta:{resourceType:'children',navSection:'categories',headerTheme:'light'}},
  {path:'/competitions',name:'competitions',component:()=>import('../components/category-layouts/CompetitionsLayout.vue'),meta:{resourceType:'competition',navSection:'categories',headerTheme:'light'}},
  {path:'/exhibitions',name:'exhibitions',component:()=>import('../components/category-layouts/ExhibitionsLayout.vue'),meta:{resourceType:'exhibition',navSection:'categories'}}
];

const router = createRouter({
  history:createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el:to.hash, behavior:'smooth', top:76 };
    return { top:0 };
  },
  routes:[
    { path:'/', name:'home', component:HomeView, meta:{ navSection:'home' } },
    { path:'/about', name:'about', component:() => import('../views/AboutView.vue'), meta:{ navSection:'about' } },
    { path:'/contact', name:'contact', component:() => import('../views/ContactView.vue'), meta:{ navSection:'contact' } },
    { path:'/contribute/project', name:'contribute-project', component:() => import('../views/ContributeProjectView.vue'), meta:{ headerTheme:'light' } },
    { path:'/centers/add', name:'add-center', component:() => import('../views/AddCenterView.vue'), meta:{ headerTheme:'light' } },
    { path:'/ar/centers/add', redirect:{ name:'add-center' } },
    { path:'/apps-websites/add', redirect:{ name:'contribute-project' } },
    { path:'/ar/apps-websites/add', redirect:{ name:'contribute-project' } },
    { path:'/apps', name:'apps', component:() => import('../views/AppsView.vue'), meta:{ resourceType:'app', navSection:'categories', headerTheme:'light' } },
    { path:'/search', name:'search', component:() => import('../views/SearchView.vue'), meta:{ headerTheme:'light' } },
    ...categoryRoutes,
    ...detailRoutes,
    { path:'/:pathMatch(.*)*', name:'not-found', component:() => import('../views/NotFoundView.vue'), meta:{ headerTheme:'light' } }
  ]
});

router.beforeEach(async (to) => {
  if(!to.path.startsWith('/ar/'))return true;
  const {legacyRedirects}=await import('../data/resources.js');
  const decodedPath = (() => { try { return decodeURI(to.path); } catch { return to.path; } })();
  const target = legacyRedirects[decodedPath] || legacyRedirects[to.path];
  return target ? { path:target, replace:true } : true;
});

export default router;
